import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Contact from "@/pages/Contact";

export const Route = createFileRoute("/en/contact")({
  head: () => buildRouteHead("/en/contact"),
  component: Contact,
});

